import {keyframes} from 'styled-components';
import {ScaleOnViewWrapProps} from '../../wraps';

export const fadeIn = keyframes`
    0% {
        opacity: 0;
        transform: scale3d(1.3, 1.3, 1);
    }
    50% {
        opacity: 0;
        transform: scale3d(1.3, 1.3, 1);
    }
    80% {
        opacity: 1;
    }
    100% {
        opacity: 1;
        transform: scale3d(1, 1, 1);
    }
`;

type ScaleProps = Omit<ScaleOnViewWrapProps, 'id'>;

/**
 * On large screens when the video can be taller than the viewport we will do the scale animation.
 * Smaller screens simply disable and keep the video full width
 * @param width
 */
export const getScaling = (isLg: boolean, isXl: boolean): ScaleProps => {
    let scaling = {
        disable: true,
        threshold: 0.8,
        minPercentVisible: 0.8
    };

    if (isLg) {
        scaling = {
            disable: false,
            threshold: 0.8,
            minPercentVisible: 0.8
        };
    } else if (isXl) {
        scaling = {
            disable: false,
            threshold: 0.8,
            minPercentVisible: 0.8
        };
    }

    return scaling;
};
